import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {removeNotification} from '@/features/notifications/slices/notifications-slice';
import CalciteAlert from '@/components/shared/CalciteAlert';

const NotificationContainer = () => {
  const notifications = useSelector((state) => state.notifications.notifications);
  const dispatch = useDispatch();

  const handleClose = (id) => {
    dispatch(removeNotification(id));
  };

  return (
    <>
      {notifications.map((notification) => (
        <CalciteAlert
          key={notification.id}
          open
          kind={notification.type}
          icon={notification.icon}
          label={notification.label}
          autoClose={notification.autoClose}
          onClose={() => handleClose(notification.id)}
        >
          {notification.title && <div slot="title">{notification.title}</div>}
          {notification.message && <div slot="message">{notification.message}</div>}
        </CalciteAlert>
      ))}
    </>
  );
};

export default NotificationContainer;
